<template>
  <div>
    <multiselect
      v-model="tag"
      :options="searchOptions"
      label="name"
      placeholder="Type to select a topic"
      :allow-empty="false"
      :internal-search="false"
      :multiple="false"
      :show-labels="false"
      @search-change="getAlgoliaTags"
    />
    <vue-good-table
      class="mt-3"
      :rows="follows"
      :columns="tableColumns"
      styleClass="vgt-table"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'tag'">
          <div class="tag-input__list">
            <div
              class="mr-2"
              style="float:left;"
            >
              {{ props.row.tag.name }}
            </div>

            <div
              v-for="t in props.row.followTags"
              class="tag-input__list__item mb-0"
              :key="t.tag.name"
            >
              <icon :icon="t.isExclusion ? 'minus-small' : 'plus-small'" />
              {{ t.tag.name }}
            </div>
          </div>
        </span>
        <span v-if="props.column.field == 'desktopNotifications'">
          <icon
            :class="{'text-success': props.row.receiveDesktopNotifications }"
            :icon="props.row.receiveDesktopNotifications ? 'tick-small' : 'minus-small'"
          />
        </span>
        <span v-if="props.column.field == 'emailNotifications'">
          <icon
            :class="{'text-success': props.row.receiveEmailNotifications }"
            :icon="props.row.receiveEmailNotifications ? 'tick-small' : 'minus-small'"
          />
        </span>
        <span v-if="props.column.field == 'whatsAppNotifications'">
          <icon
            :class="{'text-success': props.row.receiveWhatsappNotifications }"
            :icon="props.row.receiveWhatsappNotifications ? 'tick-small' : 'minus-small'"
          />
        </span>
        <span v-if="props.column.field == 'modal'">
          <icon
            @click.native="showModalFor(props.row)"
            icon="settings-small"
          />
        </span>
      </template>
    </vue-good-table>

    <follow-modal
      :algolia="algolia"
      :current-follow="currentFollow"
      :tag-id="currentFollow ? currentFollow.tag.id : tagId"
      :user="user"
      for-others
      :axios="gateway"
      @unfollowed="unfollowed"
      @followed="followed"
      @updated="updated"
      @unable-to-follow="error('follow')"
      @unable-to-unfollow="error('unfollow')"
    />
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

import algolia from '@/algolia'
import FollowModal from '@frontend/follow-modal'
import {errorNotification, successNotification} from '@/notifications'
import gateway from '@/gateway'

export default {
  props: {
    user: {
      required: true,
      type: Object,
    },
  },

  watch: {
    tag () {
      if (this.tag) {
        this.tagId = parseInt(this.tag.objectID, 10)
        this.currentFollow = this.follows.find((follow) => follow.tag.id === this.tagId)
        this.$modal.show('follow')
      }
    },
  },

  components: {
    FollowModal,
    VueGoodTable,
  },

  data () {
    return {
      algolia,
      gateway,
      tagId: null,
      follows: [],
      tag: null,
      searchOptions: [],
      currentFollow: null,
      tableColumns: [
        {
          label: 'Tag',
          field: 'tag',
        },
        {
          label: 'Desktop notifications',
          field: 'desktopNotifications',
        },
        {
          label: 'Email notifications',
          field: 'emailNotifications',
        },
        {
          label: 'WhatsApp notifications',
          field: 'whatsAppNotifications',
        },
        {
          label: '',
          field: 'modal',
        },
      ],
    }
  },

  methods: {
    followInclude (follow) {
      if (follow.followTags[0] && follow.followTags[0].isExclusion === false) {
        return follow.followTags[0].tag.name
      }
    },

    getAlgoliaTags (query) {
      const index = this.algolia.initIndex('tags')
      index.search(query, (e, content) => {
        this.searchOptions = content.hits
      })
    },

    showModalFor (follow) {
      this.currentFollow = follow
      this.$modal.show('follow')
    },

    error (type) {
      this.$notify(errorNotification(`Unable to ${type} at this time.`))
    },


    unfollowed (follow) {
      this.$notify(successNotification(`${this.user.first_name} is no longer following ${follow.tag.name}`))
      const index = this.follows.findIndex((f) => f.tag.id === follow.tag.id)
      if (index !== -1) {
        this.follows.splice(index, 1)
      }
    },

    followed (follow) {
      this.$notify(successNotification(`${this.user.first_name} is now following ${follow.tag.name}`))
      this.follows.push(follow)
    },

    updated (follow) {
      this.$store.dispatch('follow/updateCurrent', follow)
      this.$notify(successNotification(`${this.user.first_name}'s settings have been updated for ${follow.tag.name}`))
    },
  },

  async mounted () {
    const response = await gateway.get(`crm/follows/?userId=${this.user.id}`)

    this.follows = response.data.data
  },
}
</script>
